import gql from 'graphql-tag';

export const getNFCTags = gql`
  query ($application: Int) {
    getNFCTags(application: $application, active: true) {
      deviceId
      application {
        applicationId
      }
      name
      model {
        modelId
        name
        remark
      }
      serial
      mac
      region
      longitude
      latitude
      remark
      optional
      date
      battery
      live
      humidity
      temperature
      x
      y
      z
      tags
    }
  }
`

export const getNFCTagsConnection = gql`
  query ($whereArgs: NFCTagsConnectionInput, $first: Int, $last: Int, $before: String, $after: String,
  $models: [Int], $searchParam: String, $searchTerm: String) {
    getNFCTagsConnection(whereArgs: $whereArgs, first: $first, last: $last, before: $before, after: $after,
    models: $models, searchParam: $searchParam, searchTerm: $searchTerm) {
      edges {
        node {
          deviceId
          application {
            applicationId
          }
          name
          model {
            modelId
            name
            remark
          }
          serial
          mac
          region
          longitude
          latitude
          remark
          optional
          date
          battery
          live
          humidity
          temperature
          x
          y
          z
          tags
        }
	      cursor
      }
    	nextToken
    	totalCount
    }
  }
`

export const getNFCTagsByParams = gql`
  query ($serial: String, $mac: String) {
    getNFCTags(serial: $serial, mac: $mac, active: true) {
      deviceId
      serial
      mac
    }
  }
`

export const countNFCTagsByLatLngQuery = gql`
  query ($application: Int, $models: [Int]) {
    countNFCTagsByLatLng(application: $application, models: $models) {
      count
      latitude
      longitude
    }
  }
`

export const countSerialRangeQuery = gql`
  query ($application: Int, $serialRangeStart: Int, $serialRangeEnd: Int) {
    countSerialRange(
      application: $application,
      serialRangeStart: $serialRangeStart,
      serialRangeEnd: $serialRangeEnd,
    ) {
      count
    }
  }
`

export const getSerialRangeQuery = gql`
  query ($application: Int) {
    getSerialRange(application: $application) {
      serialRangeStart
      serialRangeEnd
    }
  }
`
